import _ from 'underscore';

/**
 * 汎用処理
 */
export default class Utils {

  /**
   * 時間汎用処理
   */
  static time = {

    /**
     * 差分の時間/分を配列で取得する
     */
    minuteDistance : function (src:Date, dst:Date) {

      src = new Date(src);
      dst = new Date(dst);

      var SECOND_MILLISECOND = 1000,
          MINUTE_MILLISECOND = 60 * SECOND_MILLISECOND;
          // HOUR_MILLISECOND = 60 * MINUTE_MILLISECOND;
          // DAY_MILLISECOND = 24 * HOUR_MILLISECOND;
          // WEEK_MILLISECOND = 7 * DAY_MILLISECOND,
          // YEAR_MILLISECOND = 365 * DAY_MILLISECOND;

      var deltaMillsecond = dst.getTime() - src.getTime();
      deltaMillsecond = Math.floor(deltaMillsecond / MINUTE_MILLISECOND);

      var m = (deltaMillsecond % 60 < 10) ? "0" + (deltaMillsecond % 60) :  (deltaMillsecond % 60);      

      return {h:(Math.floor(deltaMillsecond / 60)), m:m};
    },
  }

  /**
   * 日付汎用処理
   */
  static date = {

    /**
     * Dateオブジェクトクローン
     */
    clone(dt:Date){
      return new Date(dt.getTime());
    },

    /**
     * 現在日時ミリ秒を取得する
     */
    currentTime(){
      return new Date().getTime();
    },

    /**
     * Date型をIonicが標準的に扱うISO日時に変換する
     * https://ionicframework.com/docs/api/components/datetime/DateTime/
     */
    isoDatetimeFromDate(d:Date):string{
      var d2 = new Date(d.getTime());
      return d2.toISOString();
    },

    /**
     * Ionicが標準的に扱うISO日時からDate型へ変換する
     */
    dateFromIsoDatetime(isoString:string):Date{
      var d = new Date(isoString);
      return new Date(d.getTime());
    },

    /**
     * Ionicが標準的に扱うISO日時から標準日時表記へ変換する
     */
    isoDatetimeFormat(isoString:string):string{
      return Utils.date.getBasicDatetime(Utils.date.dateFromIsoDatetime(isoString));
    },

    /**
     * 日付計算
     */
    calcDate(dt:Date, adjustDate:number){
      var dt2 = Utils.date.clone(dt);
      dt2.setDate(dt2.getDate() + adjustDate);
      return dt2;
    },

    /**
     * yy年MM月dd日
     */
    getBasicDate(dt?:Date):string{
      if(!dt) dt = new Date();
      return Utils.date.format(Utils.date.clone(dt), "yy年MM月dd日");
    },

    /**
     * yy年MM月dd日 HH:mm
     */
    getBasicDatetime(dt?:Date):string{
      if(!dt) dt = new Date();
      return Utils.date.format(Utils.date.clone(dt), "yy年MM月dd日 HH:mm");
    },

    /**
     * YYYY-MM-DD 
     */
    getYYYYMMDD_hyphen(dt?:Date):string{
      if(!dt) dt = new Date();
      return Utils.date.format(Utils.date.clone(dt), "yyyy-MM-dd");
    },

    getDate_yyyymm_hyphen: function(yyyymm_hyphen){
      return new Date(yyyymm_hyphen.substr(0,4), yyyymm_hyphen.substr(5,2) - 1, 1);
    },

    getAdjustMonth: function(d:Date, adjust:number):Date{
      d.setMonth(d.getMonth() + adjust);
      return d;
    },

    getAdjustDay: function(d:Date, adjust:number):Date{
      d = Utils.date.clone(d);
      d.setDate(d.getDate() + adjust);
      return d;
    },

    getFirstDate: function(d:Date){
      return new Date(d.getFullYear(), (d.getMonth()), 1);
    },

    getLastDate: function(d:Date){
      return new Date(d.getFullYear(), (d.getMonth() + 1), 0);
    },

    formatFromIso(dt, pattern:string):string{
      if(!dt) return "";
      return Utils.date.format(new Date(dt), pattern);
    },

    getDateFromHyphen(dateHyphen){
      return new Date(dateHyphen.replace( /-/g , "/"));
    },

    format(dt:Date, pattern:string):string{

      if(!dt) dt = new Date();

      var MONTH = [
        'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
      ];
      var WEEK = [
        '日', '月', '火', '水', '木', '金', '土'
      ];

      var year    = dt.getFullYear();
      var month   = dt.getMonth();
      var date    = dt.getDate();
      var day     = dt.getDay();
      var hours   = dt.getHours();
      var minutes = dt.getMinutes();
      var seconds = dt.getSeconds();

      var patterns = {
        'yyyy': String('0000' + year).slice(-4),
        'yy': year.toString().substr(2, 2),
        'y': year,

        'MMMM': MONTH[month],
        'MMM': MONTH[month].substr(0, 3),
        'MM': String('00' + (month+1)).slice(-2),
        'M': (month+1),

        'dd': String('00' + date).slice(-2),
        'd': date,

        'EEEE': WEEK[day],

        'HH': String('00' + hours).slice(-2),
        'H': hours,

        'mm': String('00' + minutes).slice(-2),
        'm': minutes,

        'ss': String('00' + seconds).slice(-2),
        's': seconds,
      };

      var regstr = '(' + Object.keys(patterns).join('|') + ')';
      var re = new RegExp(regstr, 'g');

      return pattern.replace(re, function(str) {
        return patterns[str];
      });

      // return "";
    },

    /**
     * ２つの日時を比較し、差異を秒数で取得する
     * ex.) @return 120 -> 2分差を現す 
     */
    getElapsedTime(targetDateStr, baseDateStr):number {

      var targetDate = new Date(targetDateStr);
      var baseDate = (baseDateStr) ? new Date(baseDateStr) : new Date();

      return Math.ceil((baseDate.getTime() - targetDate.getTime()) / 1000);
    },

    /**
     * ２つの日時を比較し、◯分前を取得する
     */
    getRelativeTime (targetDateStr, baseDateStr):string {

      var elapsedTime = this.getElapsedTime(targetDateStr, baseDateStr);

      var message = null;

      // これ以下で一定時間未満のごとのメッセージの表示方法を条件分岐
      // 表示する数字が1桁のときは関数 digit で頭に半角スペースを付ける
      if (elapsedTime < 60) { //  1 分未満
        message = 'たった今';
      } else if (elapsedTime < 120) { //  2 分未満
        message = '1分前';
      } else if (elapsedTime < (60 * 60)) { //  1 時間未満
        message = '' + (Math.floor(elapsedTime / 60) < 10 ? ' ' : '') + Math.floor(elapsedTime / 60) + '分前';
      } else if (elapsedTime < (120 * 60)) { //  2 時間未満
        message = '1時間前';
      } else if (elapsedTime < (24 * 60 * 60)) { //  1 日未満
        message = '' + (Math.floor(elapsedTime / 3600) < 10 ? ' ' : '') + Math.floor(elapsedTime / 3600) + '時間前';
      } else if (elapsedTime < (7 * 24 * 60 * 60)) { // 1 週間未満
        message = '' + (Math.floor(elapsedTime / 86400) < 10 ? ' ' : '') + Math.floor(elapsedTime / 86400) + '日前';
      } else { // 1 週間以上
        message = '' + (Math.floor(elapsedTime / 604800) < 10 ? ' ' : '') + Math.floor(elapsedTime / 604800) + '週間前';
      }
      return message;
    }
  };

  /**
   * オブジェクト複製
   */
  static clone(t:any):any{
    return JSON.parse(JSON.stringify(t));
  }

  /**
   * オブジェクト内からフルネームを取得する
   */
  static getFullName(p):string{
    if(_.isEmpty(p)) return null;
    return p["name_first"] + " " + p["name_last"];
  }

  /**
   * mongoデータからIDを取得する
   */
  static getMongoId(p):string{
    if(_.isEmpty(p)) return null;
    return p["id"];
  }
}


// WEBPACK FOOTER //
// ./src/_com/utils.ts